/* eslint react/no-unknown-property: 0 */

import React, { useRef } from 'react'
import { Camera } from 'three'

import { Canvas, Scene } from 'components/3DScene'
import Devices from './Devices'

import { Container, OuterContainer } from './styled'

import { IDeviceShowcase } from './types'

function DeviceShowcase({
  projects,
  portfolioContainerRef,
  projectDeviceRefs,
  setProjectDeviceRef,
}: IDeviceShowcase) {
  const cameraRef = useRef<Camera>()

  return (
    <OuterContainer>
      <Container>
        <Canvas>
          <Scene
            cameraRef={cameraRef}
            cameraProps={{
              position: [0, 0, 2.5],
            }}
            spotlightProps={{
              position: [0, 10, 3],
              intensity: 20,
            }}
          />
          <Devices
            cameraRef={cameraRef}
            projects={projects}
            portfolioContainerRef={portfolioContainerRef}
            projectDeviceRefs={projectDeviceRefs}
            setProjectDeviceRef={setProjectDeviceRef}
          />
        </Canvas>
      </Container>
    </OuterContainer>
  )
}

export default React.memo(DeviceShowcase)
